import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiConfig, API_CONFIG } from './api-conf';

@Injectable({
  providedIn: 'root',
})
export class ApiGatewayService {
  private _endpoint: string;
  private options: {};

  constructor(
    @Inject(API_CONFIG) config: ApiConfig,
    private http: HttpClient,
  ) {
    this._endpoint = config.url;
    this.options = config.options;
  }

  set endpoint(val: string) {
    this._endpoint = val;
  }

  get endpoint(): string {
    return this._endpoint;
  }

  get<T>(action: string, host = '', opts: {} | null = null) {
    let options = { ...this.options };
    if (opts) {
      options = { ...options, ...opts };
    }
    return this.http.get<T>(this.makeurl(action, host), options);
  }

  post<Type, RType>(action: string, body: Type) {
    const options = { withCredentials: true };
    return this.http.post<RType>(this.makeurl(action), body, options);
  }

  patch<Type, RType>(action: string, body: Type) {
    const options = { withCredentials: true };
    return this.http.patch<RType>(this.makeurl(action), body, options);
  }

  put<Type>(action: string, body: Type) {
    return this.http.put<Type>(this.makeurl(action), body, this.options);
  }

  delete<Type>(action: string) {
    const options = { withCredentials: true };
    return this.http.delete<Type>(this.makeurl(action), options);
  }

  makeurl(action: string, host = '') {
    if (host) {
      return host + '/' + action;
    }

    return this.endpoint + action;
  }
}
